/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Ai_Chat_Suggestion_RevenueInputs */

const en_admin_ai_chat_suggestion_revenue = /** @type {(inputs: Admin_Ai_Chat_Suggestion_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is my revenue month by month?`)
};

const de_admin_ai_chat_suggestion_revenue = /** @type {(inputs: Admin_Ai_Chat_Suggestion_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie hat sich mein Umsatz Monat für Monat entwickelt?`)
};

const es_admin_ai_chat_suggestion_revenue = /** @type {(inputs: Admin_Ai_Chat_Suggestion_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuáles son mis ingresos mes a mes?`)
};

const fr_admin_ai_chat_suggestion_revenue = /** @type {(inputs: Admin_Ai_Chat_Suggestion_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quel est mon chiffre d'affaires mois par mois ?`)
};

const nl_admin_ai_chat_suggestion_revenue = /** @type {(inputs: Admin_Ai_Chat_Suggestion_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is mijn omzet per maand?`)
};

/** @type {(inputs: Admin_Ai_Chat_Suggestion_RevenueInputs) => LocalizedString} */
const it_admin_ai_chat_suggestion_revenue = en_admin_ai_chat_suggestion_revenue;

/** @type {(inputs: Admin_Ai_Chat_Suggestion_RevenueInputs) => LocalizedString} */
const pt_br2_admin_ai_chat_suggestion_revenue = en_admin_ai_chat_suggestion_revenue;

/** @type {(inputs: Admin_Ai_Chat_Suggestion_RevenueInputs) => LocalizedString} */
const pl_admin_ai_chat_suggestion_revenue = en_admin_ai_chat_suggestion_revenue;

/** @type {(inputs: Admin_Ai_Chat_Suggestion_RevenueInputs) => LocalizedString} */
const hu_admin_ai_chat_suggestion_revenue = en_admin_ai_chat_suggestion_revenue;

/** @type {(inputs: Admin_Ai_Chat_Suggestion_RevenueInputs) => LocalizedString} */
const ro_admin_ai_chat_suggestion_revenue = en_admin_ai_chat_suggestion_revenue;

/**
* | output |
* | --- |
* | "What is my revenue month by month?" |
*
* @param {Admin_Ai_Chat_Suggestion_RevenueInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_ai_chat_suggestion_revenue = /** @type {((inputs?: Admin_Ai_Chat_Suggestion_RevenueInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Ai_Chat_Suggestion_RevenueInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_ai_chat_suggestion_revenue(inputs)
	if (locale === "de") return de_admin_ai_chat_suggestion_revenue(inputs)
	if (locale === "es") return es_admin_ai_chat_suggestion_revenue(inputs)
	if (locale === "fr") return fr_admin_ai_chat_suggestion_revenue(inputs)
	if (locale === "nl") return nl_admin_ai_chat_suggestion_revenue(inputs)
	if (locale === "it") return it_admin_ai_chat_suggestion_revenue(inputs)
	if (locale === "pt-BR") return pt_br2_admin_ai_chat_suggestion_revenue(inputs)
	if (locale === "pl") return pl_admin_ai_chat_suggestion_revenue(inputs)
	if (locale === "hu") return hu_admin_ai_chat_suggestion_revenue(inputs)
	return ro_admin_ai_chat_suggestion_revenue(inputs)
});
export { admin_ai_chat_suggestion_revenue as "admin.ai_chat.suggestion_revenue" }